import { useState } from 'react';
import { PartnerType, PromotionEntityType, SubBrokerType } from '../../shared/generated';
import { getLocalTranslation } from '../../utils/i18nKit';
export var useTripartiteCooperationText = function useTripartiteCooperationText() {
  var _useState = useState({
    title: '',
    brokerCommissionText: '',
    brokerFeeText: '',
    underwritingFeeText: '',
    underwritingFeeCapText: ''
  }),
      tripartiteCooperationMultilingualInfo = _useState[0],
      setTripartiteCooperationMultilingualInfo = _useState[1];

  var updateTripartiteCooperationMultilingualInfo = function updateTripartiteCooperationMultilingualInfo(source, extraInfo) {
    var _getLocalTranslation = getLocalTranslation(),
        $t = _getLocalTranslation.$t;

    var isPartner = false;

    if (extraInfo !== null && extraInfo !== void 0 && extraInfo.promotionType) {
      isPartner = extraInfo.promotionType === PromotionEntityType.PARTNER_PROMOTION;
    }

    if (!isPartner) {
      isPartner = source === PartnerType.GENERAL || (extraInfo === null || extraInfo === void 0 ? void 0 : extraInfo.subBrokerType) === SubBrokerType.PARTNER;
    }

    var info = {
      title: isPartner ? $t('kit:partner') : $t('kit:broker'),
      brokerCommissionText: isPartner ? $t('kit:partners.partner_referral_fee') : $t('kit:quotes.broker_commission'),
      brokerFeeText: isPartner ? $t('kit:partners.partner_fee') : $t('kit:quotes.broker_fee'),
      underwritingFeeText: $t('kit:brokers.underwriting_fee_from_jove'),
      underwritingFeeCapText: $t('kit:brokers.underwriting_fee_cap'),
      brokerCommissionDiscountText: isPartner ? $t('kit:partners.customer_discount') : $t('kit:quotes.broker_commission_discount')
    };
    setTripartiteCooperationMultilingualInfo(info);
    return info;
  };

  return {
    updateTripartiteCooperationMultilingualInfo: updateTripartiteCooperationMultilingualInfo,
    tripartiteCooperationMultilingualInfo: tripartiteCooperationMultilingualInfo
  };
};